import { Camera, X } from "@phosphor-icons/react";
import { toast } from "sonner";

export const MAX_PHOTOS = 3;

export default function ReviewPhotos({ files, setFiles }) {
  function onPick(e) {
    const picked = Array.from(e.target.files || []);
    e.target.value = "";
    const ok = picked.filter((f) => {
      if (f.size > 5 * 1024 * 1024) { toast.error(`${f.name} is too large (max 5 MB).`); return false; }
      return true;
    });
    const next = [...files, ...ok.map((f) => ({ file: f, preview: URL.createObjectURL(f) }))];
    if (next.length > MAX_PHOTOS) toast.message(`Only ${MAX_PHOTOS} photos per review — extras were skipped.`);
    setFiles(next.slice(0, MAX_PHOTOS));
  }
  return (
    <div className="flex flex-wrap gap-3">
      {files.map((f, i) => (
        <div key={f.preview} className="relative w-20 h-20 rounded-sm overflow-hidden border border-border">
          <img src={f.preview} alt="" className="w-full h-full object-cover" />
          <button type="button" data-testid={`review-photo-remove-${i}`} aria-label="Remove photo"
            onClick={() => setFiles(files.filter((_, j) => j !== i))}
            className="absolute top-1 right-1 bg-black/60 text-white rounded-full p-0.5 hover:bg-[#C84A31] transition-colors">
            <X size={12} />
          </button>
        </div>
      ))}
      {files.length < MAX_PHOTOS && (
        <label data-testid="review-photo-picker"
          className="w-20 h-20 border border-dashed border-border rounded-sm flex flex-col items-center justify-center gap-1 text-muted-foreground cursor-pointer hover:border-[#C84A31] hover:text-[#C84A31] transition-colors">
          <Camera size={22} weight="duotone" />
          <span className="text-[10px] uppercase tracking-widest">{files.length}/{MAX_PHOTOS}</span>
          <input data-testid="review-photo-input" type="file" multiple accept="image/jpeg,image/png,image/webp" onChange={onPick} className="hidden" />
        </label>
      )}
    </div>
  );
}
